import { SET_ERROR_MESSAGE } from 'src/Actions/ErrorActions';

const initialState = {
  errorMessage: '',
};

const errorReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: action.payload,
      };
    default:
      return state;
  }
};

export default errorReducer;
